import { fileTypeFromBuffer } from 'file-type'

export const hasError = async (file: File): Promise<string | null> => {
  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png']
  const maxSize = 10 * 1024 * 1024 // 10MB

  // Read the file into a buffer
  const arrayBuffer = await file.arrayBuffer()
  const buffer = new Uint8Array(arrayBuffer)

  // Detect file type by magic number
  const type = await fileTypeFromBuffer(buffer)

  if (!type || !allowedTypes.includes(type.mime)) {
    return 'Upload failed. Only PDF, JPEG, or PNG files are accepted. Please delete the file and try again.'
  }

  if (file.size > maxSize) {
    return 'Upload failed. File is too large. Max file size is 10MB. Please delete the file and try again.'
  }

  return null
}
